import {SupportInfo as ApiSupportInfo} from 'app_api/billing/types';
import {supportInfoClient} from 'common/report/queries/app-api/support-info-client';

import {Store} from './store';

export interface BillingAccount {
  id: number;
  recurringServiceArr: number;
  arr: number;
}

export interface SupportInfo {
  billingAccount: BillingAccount;
  userAgeDays: number;
  supportChatEnabled: boolean;
  servicePlanIds: number[];
}

export const supportInfoStore = new Store<SupportInfo>({
  apiClient: supportInfoClient,
  defaultValue: {},
  name: `support-info`,
  transform: {
    index: (apiSupportInfo: ApiSupportInfo): SupportInfo => ({
      billingAccount: {
        id: apiSupportInfo.billing_account.id,
        recurringServiceArr: apiSupportInfo.billing_account.recurring_service_arr,
        arr: apiSupportInfo.billing_account.arr,
      },
      userAgeDays: apiSupportInfo.user_age_days,
      supportChatEnabled: apiSupportInfo.support_chat_enabled,
      servicePlanIds: apiSupportInfo.service_plan_ids,
    }),
  },
});
